import React from 'react';
import {useTranslation} from 'react-i18next';
import {Button} from '@material-ui/core';

const PostFinance = ({paymentIntent, onClose}) => {
  const {t} = useTranslation();

  const proceed = () => {
    window.location.href = paymentIntent.payment_page_url;
  };

  return (
    <>
      <div className="spacer" />
      <Button variant="outlined" color="primary" onClick={onClose}>
        {t('annuler')}
      </Button>{' '}
      &nbsp;
      <Button onClick={proceed} variant="contained" color="primary">
        {t('continuer-vers-postfinance')}
      </Button>
    </>
  );
};

export default PostFinance;
